import * as Business       from '../business';
import * as UI             from '../ui';
import * as User           from '../user';
import { connect }         from 'react-redux';
import withMainRouteParams from './with_main_route_params';


const appName = 'Broadly';


export default withMainRouteParams(
  connect((state, { businessID }) => ({
    badgeCount:   User.getBadgeCount(state),
    notification: UI.getNotification(state),
    businessName: Business.getBusinessName(state, businessID)
  }))(WindowTitle)
);


function WindowTitle({ badgeCount, notification, businessName }) {
  const hasBadgeCount   = (badgeCount > 0);
  const hasNotification = !!notification;
  const badge           = (hasBadgeCount && badgeCount) || (hasNotification && '*');
  document.title        = `${badge ? `(${badge}) ` : ''}${getWindowTitle(businessName)}`;

  return null;
}


function getWindowTitle(businessName) {
  return businessName ? `${appName} - ${businessName}` : appName;
}
